import { FirebaseConfig } from './remote-config'

export default function isReigniteResultsBlacklisted(firebaseConfig: FirebaseConfig, athlinksEventId: number) {
  const raw = firebaseConfig.config.useReigniteResultsEventBlacklist?.asString() ?? ''
  const blacklistedEvents = raw.split(',').map(x => +x).filter(y => !!y)

  return blacklistedEvents.includes(athlinksEventId)
}